import { DateIsoString } from 'bloko/blocks/calendar/datesHelper';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import { formatStringDate } from 'Utils/LastActivityTime';
import translation from 'src/components/translation';
import { Gender } from 'src/models/resume/resumeCommon.types';
import { REGULAR_SPACE } from 'src/utils/constants/symbols';

const TrlKeys = {
    were: {
        [Gender.Unknown]: 'resume.card.lastActivity.were.male',
        [Gender.Male]: 'resume.card.lastActivity.were.male',
        [Gender.Female]: 'resume.card.lastActivity.were.female',
    },
    today: 'resume.card.lastActivity.today',
    yesterday: 'resume.card.lastActivity.yesterday',
    withinWeek: {
        monday: 'resume.card.lastActivity.withinWeek.monday',
        tuesday: 'resume.card.lastActivity.withinWeek.tuesday',
        wednesday: 'resume.card.lastActivity.withinWeek.wednesday',
        thursday: 'resume.card.lastActivity.withinWeek.thursday',
        friday: 'resume.card.lastActivity.withinWeek.friday',
        saturday: 'resume.card.lastActivity.withinWeek.saturday',
        sunday: 'resume.card.lastActivity.withinWeek.sunday',
    },
    weekAgo: 'resume.card.lastActivity.weekAgo',
    withinTwoWeeks: 'resume.card.lastActivity.withinTwoWeeks',
    moreThanTwoWeeks: 'resume.card.lastActivity.moreThanTwoWeeks',
};

interface Props {
    gender: Gender;
    dateIsoString: DateIsoString;
}

const LastActivity: TranslatedComponent<Props> = ({ gender, dateIsoString, trls }) => {
    return (
        <span suppressHydrationWarning>
            {trls[TrlKeys.were[gender]]}
            {REGULAR_SPACE}
            {formatStringDate(
                dateIsoString,
                {
                    today: trls[TrlKeys.today],
                    yesterday: trls[TrlKeys.yesterday],
                    withinWeek: [
                        trls[TrlKeys.withinWeek.sunday],
                        trls[TrlKeys.withinWeek.monday],
                        trls[TrlKeys.withinWeek.tuesday],
                        trls[TrlKeys.withinWeek.wednesday],
                        trls[TrlKeys.withinWeek.thursday],
                        trls[TrlKeys.withinWeek.friday],
                        trls[TrlKeys.withinWeek.saturday],
                    ],
                    weekAgo: trls[TrlKeys.weekAgo],
                    withinTwoWeeks: trls[TrlKeys.withinTwoWeeks],
                    moreThanTwoWeeks: trls[TrlKeys.moreThanTwoWeeks],
                },
                false
            )}
        </span>
    );
};

export default translation(LastActivity);
